export default "__VITE_ASSET__Clv1NwUX__"